const calcName = (name, affiliateId) => {
    const affId = affiliateId != null && affiliateId !== '' ? parseInt(affiliateId, 10) : 0
    switch (name) {
        case 'TEST':
            return 'Test Job'
        case 'RATE':
            return 'Change Campaign Rate'
        case 'PUBRATE':
            return 'Change Pub Rate'
        case 'CANCEL':
            return 'Cancel Campaign'
        case 'PUBPULL':
            return 'Remove Pub from Campaign'
        case 'MERPULL':
            return 'Remove Pub from Advertiser'
        case 'RELAUNCH':
            return 'Relaunch Campaign'
        case 'RATE_SCH':
            return affId > 0 ? 'Special Rate Change' : 'Campaign Rate Change'       
        default:
            return name
    }
}

export default calcName